<template>
  <div class="footer">
    <div class="footer__content container">
      <div class="footer__row">
        <NuxtLink href="/">
          <img class="footer__logo" alt="Logo" :src="logoUri"/>
        </NuxtLink>
        <div class="footer__nav-items">
          <NuxtLink
            class="footer__nav-item"
            :class="{ 'footer__nav-item_active': route.path.includes(item.url) }"
            active-class="footer__nav-item_active"
            v-for="item in navItems.filter(item => !item.hidden)"
            :key="item.url"
            :href="item.url"
          >
            {{ item.title }}
          </NuxtLink>
        </div>
      </div>
      <div class="footer__row">
        <p class="footer__copyright">
          Copyright © {{ (new Date()).getFullYear() }}. All Rights Reserved By Speedway Games
        </p>
        <SocialIcons class="footer__socials"/>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import defaultLogoUri from "@/assets/images/logo.webp";

const route = useRoute();

const { getGeneralSettings } = useWebsiteContent();
const { data: generalSettings, suspense: suspenseGeneralSettings } = getGeneralSettings();

const logoUri = computed<string>(() => {
  return generalSettings.value?.logoLight || defaultLogoUri;
});

const navItems = computed(() => [
  {
    title: 'About',
    url: '/about',
  },
  {
    title: 'Careers',
    url: '/careers'
  },
  {
    title: 'News',
    url: '/news',
  },
  {
    title: 'Contact Us',
    url: '/contact-us'
  },
]);

await suspenseGeneralSettings();
</script>

<style scoped lang="scss">
.footer {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 128px 0;

  background-color: #080d1f;
  background-image: url("@/assets/images/footer.webp");
  background-position: center;
  background-size: cover;

  font-family: var(--font-family-main);

  &__content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 64px;
  }

  &__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 32px;

    @media (max-width: $md) {
      flex-direction: column;
    }
  }

  &__logo {
    height: 56px;
  }

  &__nav-items {
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    gap: 48px;

    @media (max-width: $md) {
      flex-direction: column;
      gap: 16px;
    }
  }

  &__nav-item {
    color: #f7f7f7;
    font-size: 22px;
    font-weight: 700;
    white-space: nowrap;
    text-transform: uppercase;
    text-decoration: none;

    transition: all 200ms ease-out;

    &:hover, &_active {
      color: #E43233;
    }
  }

  &__copyright {
    color: #ffffff;
    font-size: 18px;
    font-weight: 700;
    line-height: 27px;
    text-transform: uppercase;

    @media (max-width: $md) {
      text-align: center;
      order: 1;
    }
  }
}
</style>
